import { Outlet } from "react-router-dom";

import { dom } from 'app/utils';

export default function Module({ plain }: any) {
  return (
    <main className={dom.className('m-2', 'flex-auto', 'border-round', 'overflow-auto', { 'surface-0': !plain })}>
      <Outlet/>
    </main>
  );
}
